import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { isSmartphone } from '../_app/cuchillo/core/Basics';
import Footer from '../layout/Footer';

class ScrollItem__Footer extends VScroll_Item {
  _isFooterShow = false;
  _pointerEvents = "none";

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
            
    if (!isSmartphone) {
      this.onMove = () => {
        
        if (this.progress > .4) {
          if (!this._isFooterShow) {
            Footer.show();
          }
          this._isFooterShow = true;
        } else {
          if (this._isFooterShow) {
            Footer.hideLong();
          }
          this._isFooterShow = false;
        }
      };
    } else {
      
      this.onShow = () => {
        if (!this._isFooterShow) {
          Footer.show();
        }
        this._isFooterShow = true;
      }

      this.onHide = () => {
        if (this._isFooterShow) {
          Footer.hideLong();
        }
        this._isFooterShow = false;
      }
    }
  }

  dispose() {
    super.dispose();
  }
}

Scroll._registerClass('footer', ScrollItem__Footer);
